export default __webpack_public_path__ + "static/media/park_linowy_regulamin_zal_5.01e6ae69.pdf";